export const PIN_TYPES = [
  {
    value: 'cabo',
    label: 'Cabo eleitoral',
    icon: 'i-lucide-user',
    color: 'bg-amber-500',
    text: 'text-amber-700',
    bg: 'bg-amber-100',
  },
  {
    value: 'grupo',
    label: 'Grupo de apoio',
    icon: 'i-lucide-users',
    color: 'bg-emerald-500',
    text: 'text-emerald-700',
    bg: 'bg-emerald-100',
  },
  {
    value: 'evento',
    label: 'Evento',
    icon: 'i-lucide-calendar-days',
    color: 'bg-purple-500',
    text: 'text-purple-700',
    bg: 'bg-purple-100',
  },
  {
    value: 'area',
    label: 'Área (força/fraqueza)',
    icon: 'i-lucide-flag',
    color: 'bg-rose-500',
    text: 'text-rose-700',
    bg: 'bg-rose-100',
  },
];

export const AREA_CATEGORIES = [
  { value: 'forte', label: 'Forte', color: 'bg-emerald-500' },
  { value: 'fraco', label: 'Fraco', color: 'bg-rose-500' },
  { value: 'em_disputa', label: 'Em disputa', color: 'bg-amber-500' },
];

export const pinTypeMeta = v => PIN_TYPES.find(p => p.value === v) || {};
export const areaCategoryMeta = v =>
  AREA_CATEGORIES.find(a => a.value === v) || {};
